'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const testimonials = [
{
  key: 'testi-1',
  name: 'Drs. H. Bambang Sutrisno',
  role: 'Jamaah Keluarga, Agustus 2025',
  city: 'Surabaya',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bafba5cd-1763293867490.png",
  alt: 'Foto Bapak Bambang Sutrisno, jamaah asal Surabaya dengan senyum hangat',
  rating: 5,
  category: 'Family',
  text: 'Subhanallah, perjalanan yang luar biasa. Tim SAFARUNA mempersiapkan segalanya dengan detail — dari hotel Haram view, transportasi mewah, hingga muttawif yang sabar mendampingi kami. Anak-anak pun nyaman sepanjang perjalanan.',
  journey: 'Family Signature — 14 Hari'
},
{
  key: 'testi-2',
  name: 'Hj. Siti Nurhaliza Hakim',
  role: 'Jamaah Couple, April 2026',
  city: 'Jakarta',
  avatar: "https://images.unsplash.com/photo-1642928866651-ac8bad952d8a",
  alt: 'Foto Ibu Siti Nurhaliza dengan jilbab putih dan senyum cerah',
  rating: 5,
  category: 'Couple',
  text: 'Kami merayakan ulang tahun pernikahan ke-25 dengan Umrah berdua. SAFARUNA mengatur segalanya dengan sempurna — kamar Kaaba View, dinner di hotel mewah, dan pendampingan yang tidak mengganggu privasi kami.',
  journey: 'Couple Private — 10 Hari'
},
{
  key: 'testi-3',
  name: 'Prof. Dr. H. Mahmud Hasanuddin',
  role: 'Jamaah Lansia, Maret 2026',
  city: 'Bandung',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e9dcd8ec-1772799883309.png",
  alt: 'Foto Bapak Mahmud Hasanuddin, profesor senior dengan kacamata dan rambut beruban',
  rating: 5,
  category: 'Elderly',
  text: 'Saya berangkat bersama istri yang menggunakan kursi roda. SAFARUNA memastikan aksesibilitas di setiap titik — dari bandara, hotel, hingga area tawaf. Tidak ada momen yang terlewat karena keterbatasan.',
  journey: 'Elderly Special Care — 12 Hari'
},
{
  key: 'testi-4',
  name: 'Ir. Hendra Wijaya, MBA',
  role: 'Jamaah Executive, Januari 2026',
  city: 'Jakarta',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_162b39a88-1772504131532.png",
  alt: 'Foto Bapak Hendra Wijaya dengan jas formal dan tampilan profesional',
  rating: 5,
  category: 'Executive',
  text: 'Business class Saudia, Swissôtel Kaaba View, private car 24 jam, dan concierge personal yang selalu siap. Ini bukan sekadar Umrah — ini pengalaman spiritual kelas dunia. Worth every penny.',
  journey: 'Executive Private — 9 Hari'
}];


export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((a) => a === 0 ? testimonials?.length - 1 : a - 1);
  const next = () => setActive((a) => a === testimonials?.length - 1 ? 0 : a + 1);

  const t = testimonials?.[active];

  return (
    <section id="testimonials" className="py-20 lg:py-28">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-semibold uppercase tracking-widest mb-4">
            Kata Jamaah Kami
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-3">
            Lebih dari 4,800 Jamaah Telah Mempercayai Kami
          </h2>
          <div className="flex items-center justify-center gap-1 mt-3">
            {[1, 2, 3, 4, 5]?.map((s) =>
            <Star key={`avg-star-${s}`} size={20} className="text-accent fill-accent" />
            )}
            <span className="ml-2 text-muted-foreground text-sm font-semibold">4.9 / 5.0 rata-rata</span>
          </div>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="card-base p-8 lg:p-10 relative animate-fade-in" key={t?.key}>
            <Quote size={48} className="text-primary/10 absolute top-6 right-8" />

            <div className="flex items-center gap-1 mb-6">
              {Array.from({ length: t?.rating })?.map((_, si) =>
              <Star key={`tstar-${t?.key}-${si}`} size={16} className="text-accent fill-accent" />
              )}
              <span className="ml-2 px-2.5 py-1 rounded-full bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-wider">
                {t?.category}
              </span>
            </div>

            <blockquote className="text-foreground text-lg leading-relaxed mb-8 font-medium">
              "{t?.text}"
            </blockquote>

            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl overflow-hidden border-2 border-border">
                  <AppImage src={t?.avatar} alt={t?.alt} width={56} height={56} className="object-cover w-full h-full" />
                </div>
                <div>
                  <p className="font-bold text-foreground">{t?.name}</p>
                  <p className="text-muted-foreground text-sm">{t?.role}</p>
                  <p className="text-xs text-muted-foreground">{t?.city} · {t?.journey}</p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 rounded-xl border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-all duration-150 active:scale-95"
                  aria-label="Testimonial sebelumnya">
                  
                  <ChevronLeft size={18} />
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 rounded-xl border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-all duration-150 active:scale-95"
                  aria-label="Testimonial berikutnya">
                  
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials?.map((_, i) =>
            <button
              key={`dot-testi-${i}`}
              onClick={() => setActive(i)}
              className={`rounded-full transition-all duration-200 ${
              i === active ? 'w-6 h-2 bg-primary' : 'w-2 h-2 bg-muted hover:bg-muted-foreground'}`
              }
              aria-label={`Testimonial ${i + 1}`} />

            )}
          </div>
        </div>
      </div>
    </section>);

}